import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { LicenseAgreementServices } from './license-agreement.service';


@Injectable()
export class BusinessListResolver {
  constructor(private backend: LicenseAgreementServices) { }
  resolve(): Observable<any[]> {
    return this.backend.getBusinessLicenseAgreementList();
  }
}

@Injectable()
export class BusinessFeatureListResolver {
  constructor(private backend: LicenseAgreementServices) { }
  resolve(): Observable<any[]> {
    return this.backend.getBusinessFeatureLicenseAgreementList();
  }
}

